<template>
  <div>
    <div class="d-none d-md-block d-lg-none" style="margin-top: -10px;"></div>
    <div v-if="showNetworksNav" class="d-none d-lg-block d-xl-none" style="margin-top: 175px;"></div>
    <div
    v-if="this.$route.name == 'network-home' || this.$route.name == 'networks-members' || this.$route.name == 'networks-messages'
    || this.$route.name == 'networks-dashboard' || this.$route.name == 'networks-meetings' || this.$route.name == 'meeting-report'
    || this.$route.name == 'zoom-report' || this.$route.name == 'network-message-create-page' || this.$route.name == 'network-message-edit-page'
    || this.$route.name == 'networks-blog'|| this.$route.name == 'network-blog-post-create-page' || this.$route.name == 'network-blog-post-edit-page'
    || this.$route.name == 'meeting-certificates'"
    class="d-none d-lg-block d-xl-block d-xxl-block" style="margin-top: 120px;"></div>
    <div class="header navbar-sticky navbar-stuck navbar-dark" data-fixed-element>
      <MaintenanceMessage />

      <div class="navbar navbar-expand-lg"
      :class="env == 'production' ? 'bg-primary' : (env == 'stage' ? 'bg-dark' : (env == 'dev' ? 'bg-warning' : 'bg-primary bg-opacity-75'))">
        <div class="container-fluid px-2">
          <button id="navbar-toggler" data-test="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#primaryMenu" class="navbar-toggler ms-n2 me-1">
            <span class="navbar-toggler-icon"></span>
          </button>
          <router-link to="/" class="navbar-brand flex-shrink-0 order-lg-1 ms-lg-0 pe-lg-2 me-lg-4" style="margin: -5px;">
            <span>
              <img src="~resonance-theme/src/assets/img/apps/networks-logo-dark-square.svg" alt="logo" width="135px" height="50px" class="logo-light rounded" />
            </span>
          </router-link>

          <!--MOBILE-->
          <div id="primaryMenu" class="offcanvas offcanvas-collapse order-lg-2" style="color: #5a5b75; font-weight: 600; font-size: 110%;">
            <div class="offcanvas-header navbar-shadow">
              <h4 class="mt-1 mb-0 ms-3">{{ $t('Nav.menu') }}</h4>
              <button id="close" data-test="close" type="button" data-bs-dismiss="offcanvas" :aria-label="$t('Nav.close')" class="btn-close lead"></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav nav-mobile">
                <li v-for="(link, i) in activeNavLinks" :key="i" data-test="main-link" class="mb-0">
                  <router-link v-if="link.to" class="nav-link me-2"
                    :to="link.to"
                    :class="{
                      'router-link-active': link.to === '/media/' && $route.path.startsWith('/networks/collections'),
                      'router-link-inactive': link.to === '/networks' && $route.path.startsWith('/networks/collections')
                    }">
                    {{ $t(link.name) }}
                  </router-link>
                  <a v-else href="#" class="nav-link">
                    {{ $t(link.name) }}
                    <i class="fas fa-chevron-down fa-xs closed"></i>
                    <i class="fas fa-chevron-up fa-xs opened"></i>
                  </a>

                  <NetworksNav
                    v-if="link.name == 'nav.home' && showNetworksNav && currentNetwork"
                    :isMobileMenu="true"
                    :network="currentNetwork"
                    class="d-block d-lg-none"
                  ></NetworksNav>
                </li>
                <a class="nav-link pointer" @click="openHelpAndSupportModal()">Support</a>
                <div v-if="$auth.auth" class="d-block d-sm-none">
                  <li style="border-top: 1px solid #5C6D80;"></li>
                  <li style="margin: 0.8rem 1rem 0.5rem 1rem;">
                      <avatar :src="profileImageUrl" :username="fullName"
                      style="display: inline-block; width: 35px !important; height: 35px !important; background-size: 35px 35px !important;"
                      ></avatar>
                    <span style="margin-left: 10px; display: inline-block; vertical-align: super;">
                      {{ userName }}
                    </span>
                  </li>
                  <li>
                    <router-link to="/likes" class="nav-link">
                      {{ $t('likes') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </router-link>
                  </li>
                  <li>
                    <a data-umami-event="open-language-modal" href="#" class="nav-link" @click="showLanguageModal = !showLanguageModal">
                      {{ $t('Nav.language') }}
                    </a>
                  </li>
                  <li v-if="$auth.hasRole('super-admin')" style="border-top: 1px solid #5C6D80;"></li>
                  <li v-if="$auth.hasRole('super-admin')">
                    <a data-umami-event="open-login-as-modal" href="#" class="nav-link" @click="showLoginAsModal = !showLoginAsModal">
                      {{ $t('Nav.login-as') }}
                    </a>
                  </li>
                  <li style="border-top: 1px solid #5C6D80;"></li>
                  <li>
                    <a data-umami-event="sign-out" href="#" class="nav-link" @click="signOut">
                      {{ $t('Nav.logout') }}
                    </a>
                  </li>
                </div>
                <div v-if="!$auth.auth" class="d-block d-sm-none">
                  <li>
                    <a id="sign-in-link-mobile" data-umami-event="sign-in" href="#" class="nav-link" data-test="sign-in-link-mobile" @click="$bus.emit('go-to-sign-in', $route.fullPath)">
                      {{ $t('Nav.sign-in') }}
                    </a>
                  </li>
                  <li v-if="env == 'local'">
                    <a data-umami-event="open-login-as-modal" href="#" class="nav-link" @click="showLoginAsModal = !showLoginAsModal">
                      {{ $t('Nav.login-as') }}
                    </a>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <!--END MOBILE-->

          <!--DESKTOP-->
          <div class="toolbar d-flex justify-content-end order-lg-3 ms-lg-auto">
            <a id="search_query_nav" href="/search" data-test="search_query_nav" class="btn btn-secondary p-0 flex-shrink-0 toolbtn" style="width: 50px; height: 52px;">
              <i class="fa fa-search" style="padding-top: 17px;"></i>
            </a>
            <button id="whats_new" data-umami-event="open-whats-new" data-test="whats_new" :title="$t('Nav.whats-new')" class="btn btn-secondary p-0 flex-shrink-0 toolbtn beamerSelector" style="width: 50px; height: 52px;">
              <i class="fas fa-gift"></i>
            </button>
              <app-chooser currentApp="networks" :env="env" class="chooser d-none d-sm-block" />

              <button v-if="!$auth.auth" id="sign-in-link-desktop" data-umami-event="sign-in" data-test="sign-in-link-desktop" class="btn btn-round btn-primary px-3 d-none d-sm-block" @click="$bus.emit('go-to-sign-in', $route.fullPath)">
                <i class="fas fa-arrow-right-to-bracket"></i>
                {{ $t('Nav.sign-in') }}
              </button>
              <button v-if="!$auth.auth && env == 'local'" id="login_as" data-umami-event="open-login-as-modal" data-test="login_as" class="btn btn-round btn-primary px-3 d-none d-sm-block" @click="showLoginAsModal = !showLoginAsModal">
                <i class="fa fa-user m-1"></i>
                {{ $t('Nav.login-as') }}
                <span class="ms-auto fs-xs text-muted"></span>
              </button>

              <button
                v-if="$auth.auth"
                id="notification_count"
                data-test="notification_count"
                data-umami-event="open-notifications"
                aria-controls="offcanvasNotification"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNotification"
                class="btn btn-secondary p-0 flex-shrink-0 toolbtn d-none d-sm-block"
                style="position: relative; right: 4px;"
              >
                <i class="fas fa-bell" style="transform: rotate(-14deg);"></i>
                <span
                  v-if="notification_count>0"
                  class="badge rounded-pill bg-primary ms-1 bg-white"
                  style="position: absolute; right: 0px; font-size: 9px; top: 2px; color: #333 !important; padding: 3px;"
                >
                  {{ notification_count > 5 ? '5+' : notification_count }}
                </span>
              </button>

              <div v-if="$auth.auth" class="navbar-tool dropdown d-none d-sm-block">
                <a href="#" class="navbar-tool-label dropdown-toggle border border rounded-3 border-0 user-dropdown mx-2 d-flex">
                  <div style="border-radius: 50% 0% 0 50%;">
                    <avatar :src="profileImageUrl" :username="fullName" class="m-0 p-0"></avatar>
                  </div>
                  <div style="display: flex; align-items: center; justify-content: center; border-radius: 0 25px 25px 0;">
                    <span class="px-2 my-auto">
                      {{ userName }}
                      <i class="fa fa-chevron-down px-2"></i>
                    </span>
                  </div>
                </a>
                <ul class="dropdown-menu dropdown-menu-end" style="top: 2.2rem;">
                  <li>
                    <router-link to="/messages" class="dropdown-item d-flex align-items-center text-decoration-none">
                      <i class="fa fa-envelope m-1"></i>
                      {{ $t('network.Messages') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/likes" class="dropdown-item d-flex align-items-center text-decoration-none">
                      <i class="fas fa-bookmark m-1" style="font-size: 16px;"></i>
                      <i class="fa fa-star pointer m-1"
                      style="position: absolute; margin-left: 6px !important; margin-top: 1px !important; color: white; font-size: 7px;"></i>
                      {{ $t('likes') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/profile" class="dropdown-item d-flex align-items-center text-decoration-none">
                      <i class="fa fa-cog m-1"></i>
                      {{ $t('Nav.profile') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </router-link>
                  </li>
                  <li>
                    <a href="#" data-umami-event="open-language-modal" class="dropdown-item d-flex align-items-center text-decoration-none" @click="showLanguageModal = true">
                      <i class="fas fa-language fa-xl m-1"></i>
                      {{ $t('Nav.language') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </a>
                  </li>
                  <li v-if="$auth.hasRole('super-admin')" class="dropdown-divider"></li>
                  <li v-if="$auth.hasRole('super-admin')">
                    <a href="#" data-umami-event="open-login-as-modal" class="dropdown-item d-flex align-items-center text-decoration-none" @click="showLoginAsModal = !showLoginAsModal">
                      <i class="fa fa-user m-1"></i>
                      {{ $t('Nav.login-as') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </a>
                  </li>
                  <li class="dropdown-divider"></li>
                  <li>
                    <a href="#" data-umami-event="sign-out" class="dropdown-item d-flex align-items-center text-danger text-decoration-none" @click="signOut">
                      <i class="fa fa-sign-out-alt m-1"></i>
                      {{ $t('Nav.logout') }}
                      <span class="ms-auto fs-xs text-muted"></span>
                    </a>
                  </li>
                </ul>
              </div>
          </div>
          <!--END DESKTOP-->
        </div>
      </div>

      <div v-if="showNetworksNav && currentNetwork">
        <div class="d-none d-lg-block d-xl-block d-xxl-block row ps-5 pe-5 bg-dark navbar-sticky navbar-stuck"
        :style="{ 'margin-top': marginTop }">
          <NetworksNav :isMobileMenu="false" :network="currentNetwork"></NetworksNav>
        </div>
      </div>

      <!-------------------
        Modals and Canvases
      --------------------->
      <b-modal v-model="showLoginAsModal" hide-footer hide-header>
        <LoginAs @loginAsSuccess="showLoginAsModal = false" @close="showLoginAsModal = false" />
      </b-modal>

      <b-modal v-model="showLanguageModal" hide-footer hide-header class="mt-5">
        <LanguageChooser @close="showLanguageModal = false"></LanguageChooser>
      </b-modal>

      <div v-if="env == 'local'" class="position-fixed text-nowrap rounded-3 p-1 m-3 bg-secondary text-primary" style="top: -17px">
        <div class="d-block d-sm-none">Extra Small (xs)</div>
        <div class="d-none d-sm-block d-md-none">Small (sm)</div>
        <div class="d-none d-md-block d-lg-none">Medium (md)</div>
        <div class="d-none d-lg-block d-xl-none">Large (lg)</div>
        <div class="d-none d-xl-block d-xxl-none">X-Large (xl)</div>
        <div class="d-none d-xxl-block">XX-Large (xxl)</div>
      </div>
      </div>

      <HelpAndSupport :isShowModal="isShowHelpModal" />
    </div>
</template>
<script>
//import '@/lib/Beamer'; //load the "whats new component"
import LanguageChooser from '@/components/commons/LanguageChooser.vue';
import LoginAs from '@/views/auth/LoginAs.vue';
import MaintenanceMessage from '/src/views/layouts/default/_MaintenanceMessage.vue';
import navLinks from '@/router/links.js';
import NetworksNav from '@/views/layouts/nav/NetworksNav.vue';
import HelpAndSupport from '@/components/HelpAndSupport.vue';
// import Sidebar from './_Sidebar';
import { mapState } from 'vuex';
import AppChooser from 'resonance-theme/src/vue/components/AppChooser.vue';
import Avatar from 'vue-avatar';
import debounce from 'lodash/debounce';

export default {
  components: {
    LanguageChooser,
    LoginAs,
    MaintenanceMessage,
    AppChooser,
    Avatar,
    NetworksNav,
    HelpAndSupport,
  },
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'dark', // dark or light
    },
    variant: {
      type: String,
      default: 'default', // primary, info default etc
    },
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
      mobileNavbar: false,
      flipped: false /* indicates when the mode needs to be flipped */,
      navLinks: navLinks,
      showLoginAsModal: false,
      currentLanguage: 'english',
      showLanguageModal: false,
      showNetworksNav: false,
      searchQuery: '',
      isShowHelpModal: 0,
    };
  },
  computed: {
    activeNavLinks() {
      if (this.$auth.auth) {
        if (this.$auth.hasRole('super-admin')) {
          return navLinks;
        } else {
          return navLinks.filter(link => !link.requiresAdmin); // filter out links only visible for admins
        }
      } else {
        return navLinks.filter(link => !link.requiresLogin); // filter out links that require login
      }
    },
    supportedLanguages() {
      return this.$i18n.i18next.options.supportedLanguages;
    },
    currentMode() {
      var mode = this.mode;
      var flippedMode = mode == 'dark' ? 'light' : 'dark';

      return this.flipped ? flippedMode : mode;
    },
    currentVariant() {
      return this.flipped ? 'light' : this.variant;
    },
    ...mapState({
      maintenance: state => state.maintenance,
    }),
    notification_count() {
      return this.$store.state.notifications.notifications.length;
    },
    fullName() {
      return this.$store.state.auth.user.first_name + ' ' + this.$store.state.auth.user.last_name;
    },
    currentNetwork() {
      return this.$store.state.network.currentNetwork;
    },
    profileImageUrl() {
      return this.$store.getters['user'].profile_image_url;
    },
    userName() {
      let name = this.$store.state.auth.user.first_name + ' ' + this.$store.state.auth.user.last_name;
      return name.length > 15 ? `${name.substring(0, 15)}...` : name;
    },
    marginTop() {
      let top = 75;
      let maintenanceHeight = 40;
      if (this.maintenance) top += maintenanceHeight;
      return top.toString() + 'px !important';
    },
  },
  watch: {
    maintenance: {
      handler(newV) {
        console.log('in watcher for maintenance', newV);
        this.updateMainContentHeight();
      },
    },
    $route: {
      handler: 'checkNetworksNav',
      immediate: true,
    },
    searchQuery: debounce(function (newV) {
      sessionStorage.setItem('searchQuery', newV);
      this.searchQuery = '';
      if (this.$route.name != 'search') {
        this.$router.push('search');
      } else {
        location.reload();
      }
    }, 600),
  },
  created() {
    this.$bus.on('show-mobile-navbar', this.showMobileNavbar);
    this.$bus.on('hide-mobile-navbar', this.hideMobileNavbar);
  },
  mounted() {
    this.updateMainContentHeight();
    this.checkNetworksNav();
    /* Use this to tweak the mode/variant of the navbar after scrolling
    will also need position:sticky on the navbar styling itself*/
    this.$nextTick(() => {
      // debounced or throttled scroll event listener
      this.handleScroll = debounce(() => {
        if (this.fixed) return; // exit if navbar is fixed

        var headerHeight = 300; // auto detect based on <header>
        if (document.getElementById('headerTop')) {
          headerHeight = document.getElementById('headerTop').clientHeight - 50;
        }
        if (document.querySelector('header.header')) {
          headerHeight = document.querySelector('header.header').clientHeight;
        }

        var pos = document.documentElement.scrollTop;
        var classes = [];
        if (pos > 10) {
          classes.push('body-scrolled');
        }
        if (pos > 40) {
          classes.push('navbar-scrolled');
        }
        if (pos > headerHeight) {
          classes.push('header-scrolled');
        }

        // update the document body classes
        document.body.className = classes.join(' ');

        // flip navbar mode based on scroll position
        this.flipped = document.documentElement.scrollTop >= headerHeight;
      }, 200);
      window.addEventListener('resize', this.updateMainContentHeight);
      window.addEventListener('scroll', this.handleScroll);
    });

    // load networks data
    this.$store.dispatch('network/loadNetworks', { search: '' });
    this.$store.dispatch('network/loadTrendingNetworks', { search: '' });
  },
  beforeRouteUpdate(to, from, next) {
    this.checkNetworksNav();
    next();
  },
  beforeDestroy() {
    this.$bus.off('show-mobile-navbar');
    this.$bus.off('hide-mobile-navbar');
    window.removeEventListener('resize', this.updateMainContentHeight);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    checkNetworksNav() {
      const path = this.$route.path.split('/');
      if (
        path[1] === 'networks' &&
        path[2] !== 'media' &&
        path[2] !== 'collections' &&
        path[2] !== '' &&
        path.length > 2
      ) {
        this.showNetworksNav = true;
        console.log('showing networks nav');
      } else {
        this.showNetworksNav = false;
        console.log('not showing networks nav');
      }
    },
    openHelpAndSupportModal() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.isShowHelpModal = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    },
    updateMainContentHeight() {
      var navbar = this.$refs.navbar;
      if (navbar) {
        var navbarHeight = navbar.$el.clientHeight;
        var main = document.querySelector('main.main-content.no-header');

        if (main) {
          navbarHeight += 25;
          if (this.maintenance) navbarHeight += 25;

          document.querySelector('main.main-content.no-header').style.marginTop = navbarHeight + 'px';
        }
      }
    },
    showMobileNavbar() {
      this.mobileNavbar = true;
      document.body.classList.add('navbar-open');
    },
    hideMobileNavbar() {
      this.mobileNavbar = false;
      document.body.classList.remove('navbar-open');
    },
    scrollTo: function (hashtag) {
      this.hideMobileNavbar();
      setTimeout(() => {
        location.href = hashtag;
      }, 1);
    },
    signOut() {
      this.$store.dispatch('logout').then(() => {
        if (this.$route.name != 'home') {
          this.$router.push('/');
        }
      });
    },
  },
};
</script>
<style>
.dropdown-menu:focus {
  outline-width: 0px; /* chrome shows an ugly blue border outline when clicked/focussed */
}
.position-top-corner {
  top: -5px;
  left: 70%;
}
.toolbar > .toolbtn > .btn.toolbtn,
.toolbar > .toolbtn {
  background-color: transparent;
  border: none;
  width: 52px;
  height: 52px;
  border-radius: 50%; /* make it rounded */
}
.toolbar > .toolbtn > .btn.toolbtn:focus,
.toolbar > .toolbtn > .btn.toolbtn:active,
.toolbar > .toolbtn:focus,
.toolbar > .toolbtn:active {
  background-color: #0b3a5f;
}
.toolbar > .toolbtn > .btn.toolbtn:focus,
.toolbar > .toolbtn:focus {
  padding-top: 4px !important;
}
.toolbar > .toolbtn > .btn.toolbtn:hover,
.toolbar > .toolbtn:hover {
  background-color: #10558b;
}
/** customize color of the app chooser icon fill */
.toolbar .chooser svg path {
  fill: white;
}
div.dropdown.toolbtn > ul.dropdown-menu {
  top: -6px;
  position: relative;
}
.nav-mobile .vue-avatar--wrapper span{
  line-height: 11px;
  vertical-align: text-top;
}
.search{
  position: relative;
  top: 40%;
  left: 100%;
  transform: translate(-100%,-40%);
  transition: all 1s;
  width: 45px;
  height: 46px;
  background: white;
  box-sizing: border-box;
  border-radius: 25px;
  border: 2px solid white;
  padding: 5px;
  float: left;
  margin: unset;
  cursor: pointer;
}
.search-input{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;;
  height: 42.5px;
  line-height: 30px;
  outline: 0;
  border: 0;
  display: none;
  font-size: 1em;
  border-radius: 20px;
  padding: 0 20px;
}
.search-icon{
  box-sizing: border-box;
  padding: 12px 0px 14px 2px;
  width: 42.5px;
  height: 42.5px;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 50%;
  color: #5c6d80;
  text-align: center;
  font-size: 1.3em;
  transition: all 1s;
}
.search:hover{
  width: 300px !important;
}
.search:hover .search-input{
  display: block !important;
}
.search:hover .search-icon{
  background: #005f9a !important;
  color: white !important;
}
</style>